<template>
    <div :class="theme.stepperContent">
        <div :class="borderClasses"></div>
        <div :class="theme.content">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import theme from './theme.scss'

export default {
    name: 'stepper-content',
    props: {
        border: Boolean,
        theme: {
            type: Object,
            default() {
                return theme;
            }
        },
    },
    computed: {
        borderClasses() {
            return {
                [this.theme.line]: true,
                [this.theme.showBorder]: this.border,
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// StepperContent.vue?05a6c85c